export const translations = {
  id: {
    // Navigation
    nav: {
      home: 'Beranda',
      about: 'Tentang Kami',
      products: 'Produk',
      industries: 'Industri',
      contact: 'Kontak',
      requestQuotation: 'Minta Penawaran'
    },
    // Home Page
    home: {
      heroTitle: 'Mitra Terpercaya Anda untuk',
      heroTitleHighlight: 'Solusi Pasokan Industri',
      heroSubtitle: 'Menyediakan pasokan industri dengan presisi tinggi dengan pengalaman lebih dari {{years}} tahun. Material berkualitas, pengiriman andal, dan dukungan teknis ahli untuk operasi Anda.',
      viewProducts: 'Lihat Produk',
      requestQuotation: 'Minta Penawaran',
      projectsCompleted: 'Proyek Selesai',
      yearsExperience: 'Tahun Pengalaman',
      industriesServed: 'Industri Dilayani',
      productCategories: 'Kategori Produk',
      productRangeTitle: 'Jangkauan Produk Kami',
      productRangeSubtitle: 'Solusi pasokan industri komprehensif untuk aplikasi beragam',
      viewDetails: 'Lihat Detail',
      viewAllProducts: 'Lihat Semua Produk',
      whyPartnerTitle: 'Mengapa Bermitra Dengan Kami',
      whyPartnerSubtitle: 'Dibangun atas keahlian industri puluhan tahun dan kepercayaan pelanggan',
      provenReliability: 'Keandalan Terbukti',
      provenReliabilityDesc: 'Kualitas konsisten dan pengiriman tepat waktu. Rekam jejak kami berbicara sendiri dengan ratusan proyek sukses.',
      technicalExpertise: 'Keahlian Teknis',
      technicalExpertiseDesc: 'Pemahaman mendalam tentang aplikasi dan persyaratan industri. Konsultasi ahli untuk kebutuhan spesifik Anda.',
      qualityAssurance: 'Jaminan Kualitas',
      qualityAssuranceDesc: 'Hanya material bersertifikat, teruji, dan terbukti. Sistem manajemen mutu bersertifikat ISO 9001.',
      industriesTitle: 'Industri yang Kami Layani',
      industriesSubtitle: 'Mendukung sektor beragam dengan solusi industri khusus',
      learnMore: 'Pelajari Lebih Lanjut',
      ctaTitle: 'Siap untuk Memulai?',
      ctaSubtitle: 'Minta penawaran hari ini dan temukan bagaimana kami dapat mendukung operasi industri Anda dengan produk berkualitas dan layanan ahli.',
      ctaButton: 'Minta Penawaran Sekarang'
    },
    // About Page
    about: {
      pageTitle: 'Membangun Kepercayaan Melalui Keunggulan',
      story: 'Didirikan lebih dari dua dekade yang lalu, PT. Gurita Mandala Persada telah berkembang dari pemasok industri regional menjadi mitra yang diakui secara nasional untuk operasi manufaktur, konstruksi, dan industri. Komitmen kami terhadap kualitas, presisi teknis, dan layanan pelanggan telah menjadikan kami pilihan utama bagi organisasi yang membutuhkan material dan peralatan industri yang dapat diandalkan. Kami memahami bahwa operasi industri menuntut keandalan, dan kami memberikan tidak kurang dari itu.',
      missionTitle: 'Misi Kami',
      mission: 'Memberikan pasokan industri berkualitas tinggi yang memberdayakan keunggulan manufaktur dan efisiensi operasional di seluruh Indonesia.',
      visionTitle: 'Visi Kami',
      vision: 'Menjadi mitra pasokan industri paling terpercaya di Asia Tenggara, diakui karena keahlian teknis, kualitas produk, dan hubungan pelanggan jangka panjang.',
      coreValuesTitle: 'Nilai Inti Kami',
      coreValuesSubtitle: 'Prinsip yang memandu semua yang kami lakukan',
      reliability: 'Keandalan',
      reliabilityDesc: 'Kualitas konsisten dan pengiriman tepat waktu, setiap saat',
      expertise: 'Keahlian Teknis',
      expertiseDesc: 'Pengetahuan mendalam tentang aplikasi dan persyaratan industri',
      quality: 'Jaminan Kualitas',
      qualityDesc: 'Hanya material industri bersertifikat, teruji, dan terbukti',
      partnership: 'Kemitraan Pelanggan',
      partnershipDesc: 'Hubungan jangka panjang dibangun atas kepercayaan dan kinerja',
      journeyTitle: 'Perjalanan Kami',
      journeySubtitle: 'Tonggak dalam jalan menuju keunggulan',
      certificationsTitle: 'Sertifikasi & Kualitas',
      certificationsSubtitle: 'Berkomitmen pada standar tertinggi',
      iso9001: 'ISO 9001',
      iso9001Desc: 'Sistem Manajemen Mutu',
      certifiedMaterials: 'Material Bersertifikat',
      certifiedMaterialsDesc: 'Semua produk memenuhi standar industri',
      industryRecognition: 'Pengakuan Industri',
      industryRecognitionDesc: 'Dipercaya oleh perusahaan terkemuka'
    },
    // Products Page
    products: {
      pageTitle: 'Solusi Pasokan Industri',
      pageSubtitle: 'Jangkauan komprehensif material dan peralatan industri berkualitas tinggi untuk aplikasi beragam',
      searchPlaceholder: 'Cari produk...',
      viewProductDetails: 'Lihat Detail Produk',
      specifications: 'Spesifikasi',
      closeModal: 'Tutup',
      ctaTitle: 'Butuh Solusi Khusus?',
      ctaSubtitle: 'Tim teknis kami dapat membantu Anda menemukan produk yang tepat untuk persyaratan spesifik Anda',
      contactTeam: 'Hubungi Tim Kami',
      noResults: 'Tidak ada produk yang ditemukan sesuai pencarian Anda.'
    },
    // Industries Page
    industries: {
      pageTitle: 'Industri yang Kami Layani',
      pageSubtitle: 'Menyediakan solusi pasokan industri khusus di berbagai sektor dengan keahlian teknis mendalam dan layanan andal',
      applicationsTitle: 'Aplikasi Industri',
      applicationsSubtitle: 'Solusi dunia nyata untuk tantangan industri kompleks',
      automatedProduction: 'Lini Produksi Otomatis',
      automatedProductionDesc: 'Katup dan sistem kontrol presisi tinggi untuk fasilitas manufaktur otomotif',
      heavyIndustry: 'Fabrikasi Industri Berat',
      heavyIndustryDesc: 'Baja struktural dan material pengelasan untuk proyek konstruksi skala besar',
      processControl: 'Sistem Kontrol Proses',
      processControlDesc: 'Pipa industri dan solusi kontrol aliran untuk pabrik pemrosesan kimia',
      ctaTitle: 'Diskusikan Persyaratan Industri Anda',
      ctaSubtitle: 'Ahli teknis kami memahami tantangan unik industri Anda dan dapat merekomendasikan solusi optimal',
      scheduleConsultation: 'Jadwalkan Konsultasi'
    },
    // Contact Page
    contact: {
      pageTitle: 'Hubungi Kami',
      pageSubtitle: 'Minta penawaran atau hubungi tim kami. Kami biasanya merespons dalam 24 jam.',
      visitUs: 'Kunjungi Kami',
      callUs: 'Hubungi Kami',
      emailUs: 'Email Kami',
      whatsappUs: 'WhatsApp Kami',
      businessHours: 'Jam Operasional',
      businessHoursWeekday: 'Senin - Jumat: 08:30 - 16:30',
      businessHoursSaturday: 'Sabtu: 08:30 - 13:00',
      quickResponse: 'Respons Cepat',
      quickResponseDesc: 'Tim kami biasanya merespons permintaan penawaran dalam 24 jam',
      formTitle: 'Minta Penawaran',
      companyName: 'Nama Perusahaan',
      contactPerson: 'Nama Kontak',
      emailAddress: 'Alamat Email',
      phoneNumber: 'Nomor Telepon',
      industry: 'Industri',
      productInterest: 'Produk yang Diminati',
      message: 'Pesan / Persyaratan',
      submitButton: 'Kirim Permintaan Penawaran',
      submitting: 'Mengirim...',
      requiredFields: 'Kolom wajib diisi. Kami menghormati privasi Anda dan tidak akan membagikan informasi Anda.',
      placeholders: {
        companyName: 'Nama perusahaan Anda',
        contactPerson: 'Nama lengkap Anda',
        email: 'email@anda.com',
        phone: '+62 *********',
        industry: 'mis., Manufaktur, Minyak & Gas',
        productInterest: 'mis., Katup, Pipa, Baja',
        message: 'Silakan deskripsikan persyaratan, kuantitas, spesifikasi, dan detail relevan lainnya...'
      },
      successTitle: 'Permintaan Penawaran Terkirim',
      errorTitle: 'Pengiriman Gagal'
    },
    // Footer
    footer: {
      tagline: 'Mitra terpercaya Anda dalam solusi pasokan industri. Kualitas, keandalan, dan keunggulan teknis.',
      quickLinks: 'Tautan Cepat',
      productsTitle: 'Produk',
      contactUs: 'Hubungi Kami',
      industrialValves: 'Katup Industri',
      pipesAndTubing: 'Pipa & Tubing',
      fittingsAndConnectors: 'Fitting & Konektor',
      steelMaterials: 'Material Baja',
      copyright: 'PT. Gurita Mandala Persada. Hak cipta dilindungi.',
      privacyPolicy: 'Kebijakan Privasi',
      termsOfService: 'Syarat Layanan'
    },
    // Product Categories
    productCategories: {
      valves: 'Katup',
      valvesDesc: 'Katup industri untuk kontrol aliran presisi dan manajemen sistem',
      pipes: 'Pipa',
      pipesDesc: 'Solusi pipa tahan lama untuk transportasi fluida dan aplikasi struktural',
      fittings: 'Fitting',
      fittingsDesc: 'Fitting dengan presisi tinggi untuk koneksi yang aman dan efisien',
      steelMaterials: 'Material Baja',
      steelMaterialsDesc: 'Produk baja berkualitas tinggi untuk konstruksi dan fabrikasi industri'
    },
    // Industries
    industryNames: {
      manufacturing: 'Manufaktur',
      manufacturingDesc: 'Menyediakan komponen presisi untuk fasilitas manufaktur otomotif, elektronik, dan umum',
      oilGas: 'Minyak & Gas',
      oilGasDesc: 'Katup tekanan tinggi, pipa, dan fitting untuk operasi upstream, midstream, dan downstream',
      construction: 'Konstruksi',
      constructionDesc: 'Baja struktural, sistem pipa, dan material untuk proyek konstruksi komersial dan industri',
      infrastructure: 'Infrastruktur',
      infrastructureDesc: 'Mendukung utilitas, pengolahan air, dan pengembangan infrastruktur publik dengan material andal',
      powerUtilities: 'Pembangkit & Utilitas',
      powerUtilitiesDesc: 'Komponen kritis untuk sistem pembangkitan, transmisi, dan distribusi listrik'
    }
  },
  en: {
    // Navigation
    nav: {
      home: 'Home',
      about: 'About Us',
      products: 'Products',
      industries: 'Industries',
      contact: 'Contact',
      requestQuotation: 'Request Quotation'
    },
    // Home Page
    home: {
      heroTitle: 'Your Trusted Partner in',
      heroTitleHighlight: 'Industrial Solutions',
      heroSubtitle: 'Delivering precision-engineered industrial supplies with over {{years}} years of excellence. Quality materials, reliable delivery, and expert technical support for your operations.',
      viewProducts: 'View Products',
      requestQuotation: 'Request Quotation',
      projectsCompleted: 'Projects Completed',
      yearsExperience: 'Years of Experience',
      industriesServed: 'Industries Served',
      productCategories: 'Product Categories',
      productRangeTitle: 'Our Product Range',
      productRangeSubtitle: 'Comprehensive industrial supply solutions for diverse applications',
      viewDetails: 'View Details',
      viewAllProducts: 'View All Products',
      whyPartnerTitle: 'Why Partner With Us',
      whyPartnerSubtitle: 'Built on decades of industrial expertise and customer trust',
      provenReliability: 'Proven Reliability',
      provenReliabilityDesc: 'Consistent quality and on-time delivery. Our track record speaks for itself with hundreds of successful projects.',
      technicalExpertise: 'Technical Expertise',
      technicalExpertiseDesc: 'Deep understanding of industrial applications and requirements. Expert consultation for your specific needs.',
      qualityAssurance: 'Quality Assurance',
      qualityAssuranceDesc: 'Only certified, tested, and proven materials. ISO 9001 certified quality management system.',
      industriesTitle: 'Industries We Serve',
      industriesSubtitle: 'Supporting diverse sectors with specialized industrial solutions',
      learnMore: 'Learn More',
      ctaTitle: 'Ready to Get Started?',
      ctaSubtitle: 'Request a quotation today and discover how we can support your industrial operations with quality products and expert service.',
      ctaButton: 'Request Quotation Now'
    },
    // About Page
    about: {
      pageTitle: 'Building Trust Through Excellence',
      story: 'Established over two decades ago, PT. Gurita Mandala Persada has grown from a regional industrial supplier to a nationally recognized partner for manufacturing, construction, and industrial operations. Our commitment to quality, technical precision, and customer service has made us the preferred choice for organizations requiring dependable industrial materials and equipment. We understand that industrial operations demand reliability, and we deliver nothing less.',
      missionTitle: 'Our Mission',
      mission: 'To deliver reliable, high-quality industrial supplies that empower manufacturing excellence and operational efficiency across Indonesia.',
      visionTitle: 'Our Vision',
      vision: 'To be Southeast Asia\'s most trusted industrial supply partner, recognized for technical expertise, product quality, and long-term customer relationships.',
      coreValuesTitle: 'Our Core Values',
      coreValuesSubtitle: 'Principles that guide everything we do',
      reliability: 'Reliability',
      reliabilityDesc: 'Consistent quality and on-time delivery, every time',
      expertise: 'Technical Expertise',
      expertiseDesc: 'Deep knowledge of industrial applications and requirements',
      quality: 'Quality Assurance',
      qualityDesc: 'Only certified, tested, and proven industrial materials',
      partnership: 'Customer Partnership',
      partnershipDesc: 'Long-term relationships built on trust and performance',
      journeyTitle: 'Our Journey',
      journeySubtitle: 'Milestones in our path to excellence',
      certificationsTitle: 'Certifications & Quality',
      certificationsSubtitle: 'Committed to the highest standards',
      iso9001: 'ISO 9001',
      iso9001Desc: 'Quality Management System',
      certifiedMaterials: 'Certified Materials',
      certifiedMaterialsDesc: 'All products meet industry standards',
      industryRecognition: 'Industry Recognition',
      industryRecognitionDesc: 'Trusted by leading companies'
    },
    // Products Page
    products: {
      pageTitle: 'Industrial Supply Solutions',
      pageSubtitle: 'Comprehensive range of high-quality industrial materials and equipment for diverse applications',
      searchPlaceholder: 'Search products...',
      viewProductDetails: 'View Product Details',
      specifications: 'Specifications',
      closeModal: 'Close',
      ctaTitle: 'Need a Custom Solution?',
      ctaSubtitle: 'Our technical team can help you find the right products for your specific requirements',
      contactTeam: 'Contact Our Team',
      noResults: 'No products found matching your search.'
    },
    // Industries Page
    industries: {
      pageTitle: 'Industries We Serve',
      pageSubtitle: 'Providing specialized industrial supply solutions across diverse sectors with deep technical expertise and reliable service',
      applicationsTitle: 'Industry Applications',
      applicationsSubtitle: 'Real-world solutions for complex industrial challenges',
      automatedProduction: 'Automated Production Lines',
      automatedProductionDesc: 'High-precision valves and control systems for automotive manufacturing facilities',
      heavyIndustry: 'Heavy Industry Fabrication',
      heavyIndustryDesc: 'Structural steel and welding materials for large-scale construction projects',
      processControl: 'Process Control Systems',
      processControlDesc: 'Industrial piping and flow control solutions for chemical processing plants',
      ctaTitle: 'Discuss Your Industry Requirements',
      ctaSubtitle: 'Our technical experts understand the unique challenges of your industry and can recommend the optimal solutions',
      scheduleConsultation: 'Schedule a Consultation'
    },
    // Contact Page
    contact: {
      pageTitle: 'Get In Touch',
      pageSubtitle: 'Request a quotation or reach out to our team. We typically respond within 24 hours.',
      visitUs: 'Visit Us',
      callUs: 'Call Us',
      emailUs: 'Email Us',
      whatsappUs: 'WhatsApp Us',
      businessHours: 'Business Hours',
      businessHoursWeekday: 'Monday - Friday: 8:30 AM - 4:30 PM',
      businessHoursSaturday: 'Saturday: 8:30 AM - 1:00 PM',
      quickResponse: 'Quick Response',
      quickResponseDesc: 'Our team typically responds to quotation requests within 24 hours',
      formTitle: 'Request a Quotation',
      companyName: 'Company Name',
      contactPerson: 'Contact Person',
      emailAddress: 'Email Address',
      phoneNumber: 'Phone Number',
      industry: 'Industry',
      productInterest: 'Product Interest',
      message: 'Message / Requirements',
      submitButton: 'Submit Quotation Request',
      submitting: 'Submitting...',
      requiredFields: 'Required fields. We respect your privacy and will never share your information.',
      placeholders: {
        companyName: 'Your company name',
        contactPerson: 'Your full name',
        email: 'your@email.com',
        phone: '+62 812 3456 7890',
        industry: 'e.g., Manufacturing, Oil & Gas',
        productInterest: 'e.g., Valves, Pipes, Steel',
        message: 'Please describe your requirements, quantities, specifications, and any other relevant details...'
      },
      successTitle: 'Quotation Request Submitted',
      errorTitle: 'Submission Failed'
    },
    // Footer
    footer: {
      tagline: 'Your trusted partner in industrial supply solutions. Quality, reliability, and technical excellence.',
      quickLinks: 'Quick Links',
      productsTitle: 'Products',
      contactUs: 'Contact Us',
      industrialValves: 'Industrial Valves',
      pipesAndTubing: 'Pipes & Tubing',
      fittingsAndConnectors: 'Fittings & Connectors',
      steelMaterials: 'Steel Materials',
      copyright: 'PT. Gurita Mandala Persada. All rights reserved.',
      privacyPolicy: 'Privacy Policy',
      termsOfService: 'Terms of Service'
    },
    // Product Categories
    productCategories: {
      valves: 'Valves',
      valvesDesc: 'Industrial-grade valves for precise flow control and system management',
      pipes: 'Pipes',
      pipesDesc: 'Durable piping solutions for fluid transport and structural applications',
      fittings: 'Fittings',
      fittingsDesc: 'Precision-engineered fittings for secure and efficient connections',
      steelMaterials: 'Steel Materials',
      steelMaterialsDesc: 'High-quality steel products for construction and industrial fabrication'
    },
    // Industries
    industryNames: {
      manufacturing: 'Manufacturing',
      manufacturingDesc: 'Supplying precision components for automotive, electronics, and general manufacturing facilities',
      oilGas: 'Oil & Gas',
      oilGasDesc: 'High-pressure valves, pipes, and fittings for upstream, midstream, and downstream operations',
      construction: 'Construction',
      constructionDesc: 'Structural steel, piping systems, and materials for commercial and industrial construction projects',
      infrastructure: 'Infrastructure',
      infrastructureDesc: 'Supporting utilities, water treatment, and public infrastructure development with reliable materials',
      powerUtilities: 'Power & Utilities',
      powerUtilitiesDesc: 'Critical components for power generation, transmission, and distribution systems'
    }
  }
};

export const getTranslation = (lang, key) => {
  const keys = key.split('.');
  let value = translations[lang];
  
  for (const k of keys) {
    if (value && typeof value === 'object') {
      value = value[k];
    } else {
      return key; // Return key if translation not found
    }
  }
  
  return value || key;
};